<template>
  <div class="name-address-comp">
    <div class="NA-title">
      <h4>{{ title }}</h4>
      <p>
        {{ text }}
      </p>
    </div>
    <div>
      <div cols="12" lg="6" class="NA-input">
        <div class="NA-input-label">First name</div>
        <div>
          <input
            type="text"
            placeholder="Enter your first name"
            v-model="nameAddressData.firstName"
          />
        </div>
      </div>
      <div cols="12" lg="6" class="NA-input">
        <div class="NA-input-label">Last name</div>
        <div>
          <input
            type="text"
            placeholder="Enter your last name"
            v-model="nameAddressData.lastName"
          />
        </div>
      </div>
    </div>
    <div>
      <div cols="12" lg="6" class="NA-input">
        <div class="NA-input-label">First line of address</div>
        <div>
          <input
            type="text"
            placeholder="Enter address line"
            v-model="nameAddressData.firstAddressLine"
          />
        </div>
      </div>
      <div cols="12" lg="6" class="NA-input">
        <div class="NA-input-label">Second line of address</div>
        <div>
          <input
            type="text"
            placeholder="Enter address line"
            v-model="nameAddressData.secondLineAddress"
          />
        </div>
      </div>
    </div>
    <div>
      <div cols="12" lg="6" class="NA-input">
        <div class="NA-input-label">Town or City</div>
        <div>
          <input
            type="text"
            placeholder="Enter town or city"
            v-model="nameAddressData.townCity"
          />
        </div>
      </div>
      <div cols="12" lg="6" class="NA-input">
        <div class="NA-input-label">Post code</div>
        <div>
          <input
            type="text"
            placeholder="Enter post code"
            v-model="nameAddressData.postCode"
          />
        </div>
      </div>
    </div>
    <div>
      <div cols="12" lg="6" class="NA-input">
        <div class="NA-input-label">Email address</div>
        <div>
          <input
            type="email"
            placeholder="Enter email address"
            v-model="nameAddressData.emailAddress"
          />
        </div>
      </div>
      <div cols="12" lg="6" class="NA-input">
        <div class="NA-input-label">
          If you are responding on behalf of an organisation
        </div>
        <div>
          <input
            type="text"
            placeholder="Enter the organisation"
            v-model="nameAddressData.organisation"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NameAddress",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    currentInput: {
      type: Object,
      default() {
        return {
          firstName: "",
          lastName: "",
          firstAddressLine: "",
          secondLineAddress: "",
          townCity: "",
          postCode: "",
          emailAddress: "",
          organisation: "",
        };
      },
    },
  },
  beforeMount() {
    this.nameAddressData = this.currentInput;
  },
  data() {
    return {
      nameAddressData: {
        firstName: "",
        lastName: "",
        firstAddressLine: "",
        secondLineAddress: "",
        townCity: "",
        postCode: "",
        emailAddress: "",
        organisation: "",
      },
    };
  },
};
</script>

<style lang="scss">
.name-address-comp {
  .NA-input {
    margin-bottom: 16px;
    .NA-input-label {
      font-size: 16px;
      color: #15243c;
      font-weight: bold;
    }
    input {
      width: 90%;
      padding: 10px;
      height: auto;
      border: rgba(#15243c, 0.2) solid 2px !important;
      outline: none;
    }
  }
}
</style>